import { Button, H1, Icon, Text } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../../Shared/urlBuilder';

export const Success = () => {
  const navigate = useNavigate();

  return (
    <WorkflowLayout
      pageTitle="Document Verification"
      onClose={() => navigate(urlBuilder.appHome.path)}
      workflowTitle="Identity Check"
      size="medium"
    >
      <Icon name="CheckmarkCircle" size="large" color="icon.success" css={{ marginBottom: 'space.300' }} />
      <H1 css={{ marginBottom: 'space.200' }}>Your documents have been submitted</H1>
      <Text as="p" color="text.weak" css={{ lineHeight: { base: 'normal', md: 'relaxed' }, marginBottom: 'space.600' }}>
        We've successfully received and started reviewing your documents. You will receive an email with an update when
        we've finished review, usually within <strong>1 business day.</strong>
      </Text>
      <Button css={{ alignSelf: { base: 'stretch', md: 'start' } }} onClick={() => navigate(urlBuilder.appHome.path)}>
        Return to home
      </Button>
    </WorkflowLayout>
  );
};
